import React from 'react'
import { useSelector } from 'react-redux'
import './criardashboardbutton.scss'

const CriarDashboardButton = ({ 
  onClick, 
  title, 
  ariaLabel,
  className = '',
  cy
}) => {
  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  return (
    <div className={`dashboard-create-wrapper ${className}`}>
            <button
        data-cy={cy}
        type="button"
        className="dashboard-create"
        title={title || nls.criardashboard || "Criar Dashboard"}
        aria-label={ariaLabel || nls.criardashboard || "Criar Dashboard"}
        onClick={onClick}
      >
        <svg
          className="dashboard-create__icon"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          aria-hidden="true"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2v13" />
          <path d="m16 6-4-4-4 4" />
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
        </svg>



        <span>{nls.criardashboard || "Share"}</span>
      </button>
    </div>
  )
}

export default CriarDashboardButton